import React from 'react'
import { Redirect } from 'react-router-dom'
import { parse, stringify } from 'query-string'
import prop from 'lodash/fp/prop'

const paths: any = {
  'password-change': '/auth/password-change',
  'invite-user': '/auth/login',
  'payment-provider-connected-mollie': '/settings/payment-providers/mollie'
}

const home = '/'

const ActionRoutes: React.FC<any> = props => {
  const [to, setTo] = React.useState<{
    pathname: string
    search: string
  } | null>(null)

  React.useEffect(() => {
    const { location } = props

    const { Action, ...params } = parse(prop('search', location))

    const pathname = paths[Action as string] || home

    const search = pathname === home ? '' : stringify(params)
    setTo({
      pathname,
      search
    })
  }, [])

  if (!to) {
    return null
  }

  return <Redirect to={to} />
}

export default ActionRoutes
